import {createRef, useEffect, useState} from 'react';
import './button.css'
import useIsMountedRef from "../../utils/mountedRef";


// example of using the component: <ButtonYesno handleChange={handleChange} setter={setActeEnMain} val1={value_0} val2={value_1}/>

const ButtonTextCustom = (props) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const isMountedRef = useIsMountedRef();
    const refVal1 = createRef();
    const refVal2 = createRef();
    let [currentRef, setCurrentRef] = useState(null)

    function EventClick(refPassed, value) {

        refPassed.current.classList.remove("item_no_selected");

        if (refPassed !== refVal1) {
            refVal1.current.classList.remove('item_selected')
            refVal1.current.classList.add('item_no_selected')
        }

        if (refPassed !== refVal2) {
            refVal2.current.classList.remove('item_selected')
            refVal2.current.classList.add('item_no_selected')
        }

        refPassed.current.classList.add('item_selected')

        setCurrentRef(refPassed);
        setSelectedValue(value);      
        refPassed.current.focus(); 

        props.handleChange(props.setter, value) // launch handleChange in parent simu
    }
    const handleKeyDown = (e, currentIndex) => {
    const buttons = [refVal1, refVal2]

        if (e.key === "ArrowRight") {
            e.preventDefault();
            if (currentIndex < buttons.length - 1) {
                const next = buttons[currentIndex + 1];
                next.current.focus();
                EventClick(next, parseInt(next.current.dataset.value));
            }
        } 
        else if (e.key === "ArrowLeft") {
            e.preventDefault();
            if (currentIndex > 0) {
                const prev = buttons[currentIndex - 1];
                prev.current.focus();
                EventClick(prev, parseInt(prev.current.dataset.value));
            }
        }
    };

    useEffect(() => {
        switch (props.defaultValue) {
            case 0:
                EventClick(refVal1, 0);
                break;
            case 1:
                EventClick(refVal2, 1);
                break;
            default:
                break;
        }
    }, [isMountedRef]);

    return (
        <div className={"item_ctn"}>

            <button data-value="0" type="button" className={"common item_no_selected item_large"} ref={refVal1} 
            tabIndex={selectedValue === 0 ? 0 : -1}
            onClick={() => {
                EventClick(refVal1, 0)
            }}
            onKeyDown={(e) => handleKeyDown(e, 0)}>
                {props.val1}
            </button>

            <button data-value="1" type="button" className={"common item_no_selected item_large"} ref={refVal2} 
            tabIndex={selectedValue === 1 ? 0 : -1}
            onClick={() => {
                EventClick(refVal2, 1)
            }}
            onKeyDown={(e) => handleKeyDown(e, 1)}>
                {props.val2}
            </button>
        </div>
    );
};

export default ButtonTextCustom;
